import { Reveal, SectionHeader } from "@/components/Reveal";
import { vereinsleben } from "@/data/content";

const Vereinsleben = () => (
  <section id="vereinsleben" className="relative bg-fw-charcoal py-24 md:py-32 text-white" data-testid="vereinsleben-section">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <SectionHeader kicker="Gemeinschaft" title={vereinsleben.title} subtitle={vereinsleben.subtitle} dark testId="vereinsleben-header" />
      <Reveal>
        <p className="max-w-2xl font-body text-lg text-white/70 mb-12">{vereinsleben.intro}</p>
      </Reveal>

      <div className="grid gap-4 md:grid-cols-3">
        {vereinsleben.events.map((e, i) => (
          <Reveal key={e.name} delay={i * 0.1}>
            <div className="group relative overflow-hidden" data-testid={`vereinsleben-event-${i}`}>
              <img
                src={e.image}
                alt={e.name}
                className="h-72 w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-fw-navy/90 via-transparent to-transparent" />
              <div className="absolute bottom-0 p-6">
                <h3 className="font-technical uppercase font-bold text-2xl text-white">{e.name}</h3>
                <span className="mt-1 block h-0.5 w-10 bg-fw-gold transition-all duration-500 group-hover:w-20" />
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Vereinsleben;
